// ----- Set up behaviors model

var HHS_behaviors = function HHS_behaviors() {

    var b = this; // reference to self

    b.toggleDrawer = function b_toggleDrawer($el, $target) {

        if ($target)
        {

            log("Action: Toggling target drawer...", $target);

            if ($target.hasClass('open'))
            {
                $target.velocity('slideUp', { duration: 400, easing: 'ease' }).removeClass('open');
                $el.removeClass('open');
            }
            else {
                $target.velocity('slideDown', { duration: 400, easing: 'ease' }).addClass('open');
                $el.addClass('open');
            }

        }

    };

    /**
     * This is the same as the above toggle drawer method, but it's not responsive. It does not reset the height to default after the transition, as this causes a flicker in beloved iOS.
     *
     *
     * @param $el
     * @param $target
     */
    b.toggleDrawerMobile = function b_toggleDrawerMobile($el, $target, $logo) {

        var openHeight;

        if ($target)
        {
            log("Action: Toggling mobile target drawer...", $target);

            if (! $target.hasClass('open')) { //open
                $target
                    .velocity("stop")
                    .css({display:'block',height:'auto'});

                //get the open height
                openHeight = $target.outerHeight();

                //close the div and transition to its open height
                $target
                    .css({height:0})
                    .velocity({height:openHeight}, {duration: 400, easing: 'ease'})
                    .addClass('open');
                $el.addClass('open');

                if ($logo) {
                    log("Trying to hide", $logo);
                    $logo.hide();
                }
            }
            else { //close
                $target
                    .velocity("stop")
                    .velocity({height:0}, {display:'none', duration: 400, easing: 'ease'})
                    .removeClass('open');
                $el.removeClass('open');

                if ($logo) {
                    $logo.show();
                }
            }

        }

    };

    // ----- Scroll windows

    b.scrollWindow = function b_scrollWindow($el, $target) {

        if ($target)
        {

            log("Action: Scrolling to target...", $target);

            var targetY = $target.offset().top;
            $('html').velocity("scroll", { offset: targetY-42, duration: 500, easing: 'ease', mobileHA: false });

        }

    };

    // ----- Close lightbox

    b.closeLightbox = function b_closeLightbox() {

        log("Action: Closing active lightbox.");

        $.magnificPopup.close();

    };

    // ----- Open social popup
    // TODO

    b.openSocialPopup = function b_openSocialPopup() {
    };

    // ----- Ministry Counters only when Visible on Page


};

HHS.behaviors = new HHS_behaviors();



// ----- Action routers

HHS.actions = {};

HHS.actions.clickActionRouter = function clickActionRouter(e) {

    e.preventDefault();
    var $el = $(this);
    var action = $el.data('click-action');
    var actionTarget = $el.data('click-action-target');
    var HHSLogo = $el.data('hide-logo');
    var $logo = HHSLogo ? $(HHSLogo) : false;
    var $target = actionTarget ? $(actionTarget) : false;

    switch(action) {

        case 'toggleDrawer':
            HHS.behaviors.toggleDrawer($el, $target);
            break;

        case 'toggleDrawerMobile':
            HHS.behaviors.toggleDrawerMobile($el, $target, $logo);
            break;

        case 'scrollWindow':
            HHS.behaviors.scrollWindow($el, $target);
            break;

        case 'closeLightbox':
            HHS.behaviors.closeLightbox();
            break;

    }

};


HHS.actions.init = function actions_init(){

    log("Initializing Actions...");

    $('body').on(
        'click',
        '[data-click-action]',
        HHS.actions.clickActionRouter
    );

};